/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Toggle_FiltersInputs */



/**
* | output |
* | --- |
* | "Toggle event filters" |
*
* @param {Editor_Toggle_FiltersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_toggle_filters = /** @type {((inputs?: Editor_Toggle_FiltersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Toggle_FiltersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer les filtres d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisfilter umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva i filtri degli eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить фильтры событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar filtros de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换事件筛选器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントフィルターを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट फ़िल्टर को टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar filtros de eventos")
	return /** @type {LocalizedString} */ ("Toggle event filters")
});